<div
    class="container-fluid p-0 h-100 d-flex flex-column no-scrollable"
    *ngIf="$bucketData | async as bucketData; else loadingSpinner"
>
    <div
        class="d-flex flex-column row justify-content-between p-0 m-0 h-100 fadeInFast"
        *ngIf="!loading; else loadingSpinner"
    >
        <div class="col-12 p-0 m-0 position-relative center h-35">
            <ng-container
                *ngIf="circleData$ | async as circleData; else circleLoading"
            >
                <app-counting-circle
                    [current]="circleData.current"
                    [versus]="circleData.versus"
                    [variation]="circleData.variation"
                    [icon]="circleData.icon"
                ></app-counting-circle>
            </ng-container>
            <ng-template #circleLoading>
                <app-loader-default></app-loader-default>
            </ng-template>
        </div>

        <div
            class="col-12 p-0 m-0 counting-detail-container h-65"
            [ngSwitch]="app!.props?.detailNav?.active?.name"
        >
            <app-counting-main
                class="fadeInFast"
                *ngSwitchCase="'main'"
                [selectedLocalBusiness]="app.props!.selectedLocalBusiness!"
                [principalData]="bucketData.principalData"
            ></app-counting-main>

            <div
                class="fadeInFast d-flex flex-column h-100"
                *ngSwitchCase="'customers-counting'"
            >
                <div
                    class="d-flex justify-content-center gap-2 py-1 repartitionTabs"
                    *ngIf="
                        app.props!.selectedLocalBusiness!.groupsCountingEnabled
                    "
                >
                    <button
                        type="button"
                        class="repartitionTab d-flex align-items-center gap-1"
                        [class.active]="repartitionTab === 'visits'"
                        (click)="setRepartitionTab('visits')"
                    >
                        <img
                            src="/assets/svg/repartition.svg"
                            height="14px"
                            class="repartitionTab-icon"
                        />
                        <span>{{ 'visitorsTabs' | translate }}</span>
                    </button>
                    <button
                        type="button"
                        class="repartitionTab d-flex align-items-center gap-1"
                        [class.active]="repartitionTab === 'groups'"
                        (click)="setRepartitionTab('groups')"
                    >
                        <img
                            src="/assets/svg/repartition-group.svg"
                            height="14px"
                            class="repartitionTab-icon"
                        />
                        <span>{{ 'groupsTabs' | translate }}</span>
                    </button>
                </div>

                <app-counting-visit-repartition
                    class="fadeInFast flex-grow-1 overflow-hidden"
                    *ngIf="repartitionTab === 'visits'"
                    [businessId]="app.props!.selectedLocalBusiness!.id"
                    [format]="currentFormat"
                    [range]="currentRepartitionRange"
                    [calendarSelect]="app.props!.dates!.select!"
                    [calendarType]="app.props!.dates!.type!"
                >
                </app-counting-visit-repartition>

                <app-counting-groups
                    class="fadeInFast flex-grow-1 overflow-hidden"
                    *ngIf="repartitionTab === 'groups'"
                    [businessId]="app.props!.selectedLocalBusiness!.id"
                    [format]="currentFormat"
                    [range]="currentRepartitionRange"
                    [calendarSelect]="app.props!.dates!.select!"
                    [calendarType]="app.props!.dates!.type!"
                ></app-counting-groups>
            </div>

            <!--
            <app-time-passed-in-store
                class="fadeInFast"
                *ngSwitchCase="'repartition'"
            ></app-time-passed-in-store>
            -->

            <app-age-gender-recognition
                class="fadeInFast"
                *ngSwitchCase="'age-gender-recognition'"
                [calendarSelect]="app.props!.dates!.select!"
                [localBusiness]="app.props!.selectedLocalBusiness!"
                [range]="{
                    begin: app.props!.dates!.current!.start.asUnix,
                    end: app.props!.dates!.current!.end!.asUnix,
                    beginVs: app.props!.dates!.versus!.start.asUnix,
                    endVs: app.props!.dates!.versus!.end!.asUnix
                }"
            ></app-age-gender-recognition>
            <app-entry-passage
                class="fadeInFast"
                *ngSwitchCase="'entry-passage'"
                [calendarSelect]="app.props!.dates!.select!"
                [localBusiness]="app.props!.selectedLocalBusiness!"
                [range]="{
                    begin: app.props!.dates!.current!.start.asUnix,
                    beginVs: app.props!.dates!.versus!.start.asUnix
                }"
            ></app-entry-passage>
        </div>
    </div>
</div>
<ng-template #loadingSpinner>
    <div class="h-100 w-100 d-flex">
        <div class="align-self-center m-auto">
            <app-loader-default></app-loader-default>
        </div>
    </div>
</ng-template>
